module.exports = __webpack_public_path__ + "img/sm-橫式-為什麼選擇了做甜點.b5dd91e2.svg";